import styled from "styled-components";

import React, { Component, PropTypes } from "react";

import { NitroText, NitroIcon } from "nitro-components";

import Bookmark from "./Bookmark";
import HeaderAlert from "./HeaderAlert";
import HeaderStuds from "./HeaderStuds";

const MinimalHeadingProfileSection = styled.div`
	display: flex;
	flex-direction: row;  /* make main axis vertical */
	justify-content: flex-start; /* center items vertically, in this case */
	align-items: center;
	width: 50%;
`;

const MinimalHeadingProfileText = styled(NitroText)`
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`;

const MinimalHeadingSection = styled.div`
display:flex;
flex-direction: row;  /* make main axis vertical */
margin-top:10px;
justify-content: space-between;
width:100%;
`;

const MinimalIcons = styled.div`
display:flex;
flex-direction: row;
justify-content: center;
align-items: center;
width:30%;
`;

const StudSection = styled.div`
display:flex;
flex-direction: row;  /* make main axis vertical */
justify-content: flex-end; /* center items vertically, in this case */
align-items: center;
width:50%;
`;

class MinimalProfileHeading extends Component {
	constructor(props) {
		super(props);
	}

	

	render() {
		const {
			bookmarkClick,
			bookmarkActive,
			title,
			alert,
			studs,
			safteyRating,
			minimalMode,
			onStudClick,
			dashboardType
		} = this.props;

		return (
			<MinimalHeadingSection>
				<MinimalHeadingProfileSection>
				<MinimalHeadingProfileText
					size={28}
					bold
					variant="white"
				>
						{title}
				</MinimalHeadingProfileText>
					<MinimalIcons>
						<Bookmark
							onClick={bookmarkClick}
							active={bookmarkActive}
							height={35}
							width={35}
							noTopSpace={true}
							iconSize={16}
							iconLeft={5}
							right={12}
							variant={
								dashboardType === "driver"
									? "secondary"
									: "primary"
							}
						/>
						{alert && <HeaderAlert minimal />}
					</MinimalIcons>

				</MinimalHeadingProfileSection>

				<StudSection>
					<HeaderStuds
						studs={studs}
						minimalHeading
						onStudClick={onStudClick}
					/>
				</StudSection>

			</MinimalHeadingSection>
		);
	}
}

MinimalProfileHeading.propTypes = {
	bookmarkClick: PropTypes.func,
	bookmarkActive: PropTypes.bool,
	title: PropTypes.string,
	alert: PropTypes.string,
	studs: PropTypes.array,
	safteyRating: PropTypes.string,
	minimalMode: PropTypes.bool,
	onStudClick: PropTypes.func,
	dashboardType: PropTypes.string
};

MinimalProfileHeading.defaultProps = {
	// defaultProp: ''
};

export default MinimalProfileHeading;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/MinimalProfileHeading.js